<template>
  <div class="professionTaskHero">
    <img
      class="heroImage"
      v-lazy-load :data-src="heroImage"
      alt=""
      data-not-lazy
      fetchpriority="high"
      @error="noHeroImage"
    />
    <div class="heroText">
      <JoszakiHeading>
        {{ $helpers.capitalize(heroTitle) }}
      </JoszakiHeading>
      <p class="text-primary text-xl lg:text-2xl font-semibold">
        {{ $t("heroHeader.subtitle") }}
      </p>
      <JoszakiMarkdownTextBlock
        v-if="heroDescription"
        :text="heroDescription"
        class="heroDescription"
      />
    </div>
    <slot />
  </div>
</template>

<script>
import JoszakiMarkdownTextBlock from "~/components/_refactored/common/JoszakiMarkdownTextBlock.vue";

export default {
  components: {
    JoszakiMarkdownTextBlock,
  },
  props: {
    heroTitle: {
      type: String,
      required: true,
    },
    heroImage: {
      type: String,
      default: "",
    },
    heroDescription: {
      type: String,
      default: "Lorem ipsum",
    },
  },
  methods: {
    noHeroImage(e) {
      e.target.src = require("~/assets/defaultProfessionTaskHero.jpg");
    },
  },
};
</script>

<style lang="scss" scoped>
@use "styles/_all-members" as global;

.professionTaskHero {
  isolation: isolate;
  // overflow: hidden;
  position: relative;
  background-position: center;
  border-radius: 12px;

  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 35px;
  gap: 20px;

  @include global.widescreen {
    padding: 75px;
  }

  @include global.mobile {
    padding: 20px;
    flex-direction: column;
  }

  &:after {
    content: "";
    z-index: -1;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: linear-gradient(
      90.06deg,
      rgba(#f6f6f6, 0.86) 0.46%,
      rgba(#f6f6f6, 0.9) 99.96%
    );
  }

  .heroImage {
    z-index: -1;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 12px;
  }

  .heroText {
    display: flex;
    flex-direction: column;
    justify-content: center;

    @include global.touch {
      margin-right: auto;
    }

    .heroDescription {
      font-size: 20px;
      line-height: 160%;
      color: global.$blogTextColor;

      @include global.touch {
        font-size: 16px;
      }
    }
  }
}
</style>
